/**
 * QA-335 — SunEditor 가 내는 HTML 을 저장용으로 다듬는다.
 *
 * 정렬: SunEditor 는 문단 정렬을 인라인 `text-align` 으로 쓴다. 그런데 FE(storefront) sanitize 는 인라인 text-align 을
 * 지운다(ID-152). 그래서 종전 에디터처럼 class(ee-align-center/right/justify)로 바꿔 저장한다. FE·BO CSS 가 이 class 를
 * 정렬로 그린다. left 는 기본이라 class 를 붙이지 않는다.
 */
const ALIGN_CLASS: Record<string, string> = { center: 'ee-align-center', right: 'ee-align-right', justify: 'ee-align-justify' };

export const alignStyleToClass = (html: string): string => {
  if (!html || !/text-align/i.test(html)) return html;
  const tpl = document.createElement('template');
  tpl.innerHTML = html;
  tpl.content.querySelectorAll<HTMLElement>('[style*="text-align"]').forEach((el) => {
    const align = el.style.textAlign;
    el.style.removeProperty('text-align');
    if (!el.getAttribute('style')?.trim()) el.removeAttribute('style');
    // 기존 정렬 class 는 새 값으로 바꾼다.
    Object.values(ALIGN_CLASS).forEach((c) => el.classList.remove(c));
    const cls = ALIGN_CLASS[align];
    if (cls) el.classList.add(cls);
  });
  return tpl.innerHTML;
};

/** 빈 에디터 표식(<p><br></p> 등)은 빈 값으로. */
export const isEmptyEditorHtml = (html: string): boolean =>
  html.replace(/<p>(<br\s*\/?>)?<\/p>/gi, '').replace(/\s|&nbsp;/g, '') === '';

export const normalizeEditorOutput = (html: string): string => (isEmptyEditorHtml(html) ? '' : alignStyleToClass(html));
